import { UserPermissionRow } from './componenets/user-paermission-row';
import { useMemo, useState } from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import globalAuthStore from '../../../../stores/global-config-store';
import { UserPermissionValue } from '../../../../api/types/user/permissions/user-permission-value';
import { updateUserPermissions } from './operations/update-user-permissions';
import { getPermissionsDisplayText } from './componenets/get-permissions-display-text';
import { BranchPermissionStatus } from '../../../../api/types/user/permissions/update-user-permission-request';

export const UserPagePermissions = () => {
  const [originalBranchesIds, setOriginalBranchesIds] = useState<
    BranchPermissionStatus[]
  >(globalAuthStore.permissions.branchesPermissions);

  const [updatedBranchesIds, setUpdatedBranchesIds] =
    useState<BranchPermissionStatus[]>(originalBranchesIds);

  const [originalPermissions, setOriginalPermissions] = useState(
    globalAuthStore.permissions.permissions,
  );
  const [updatedPermissions, setUpdatedPermissions] =
    useState(originalPermissions);

  const getPermissionsDelta = () => {
    return updatedPermissions.filter((modifiedItem, index) => {
      const originalItem = originalPermissions[index];
      return modifiedItem.value !== originalItem.value;
    });
  };

  const handleReset = () => {
    setUpdatedPermissions(originalPermissions);
    setUpdatedBranchesIds(originalBranchesIds);
  };

  const handleSubmitUserPermissions = async () => {
    const asd = getPermissionsDelta();
    await updateUserPermissions(asd, updatedBranchesIds);
  };
  console.log(`XXXXXXX data res: ${JSON.stringify(getPermissionsDelta())}`);
  const handlePermissionChange = (
    type: string,
    newValue: UserPermissionValue,
  ) => {
    // Update the local state with the new permission value
    setUpdatedPermissions((prevPermissions) =>
      prevPermissions.map((permission) =>
        permission.type === type
          ? { ...permission, value: newValue }
          : permission,
      ),
    );
  };

  const getBranchesDelta = () => {
    return updatedBranchesIds.filter((updatedBranch) => {
      const originalBranch = originalBranchesIds.find(
        (branch) => branch.branch === updatedBranch.branch,
      );
      return originalBranch?.isAllow !== updatedBranch.isAllow;
    });
  };

  console.log(
    `XXXX get BRanches ddelta res: ${JSON.stringify(getBranchesDelta())}`,
  );

  const handleBranchesSelectUpdate = (
    e: CheckboxChangeEvent,
    branchPermissionStatus: BranchPermissionStatus,
  ) => {
    setUpdatedBranchesIds((prevBranches) =>
      prevBranches.map((branch) =>
        branch.branch === branchPermissionStatus.branch
          ? { ...branch, isAllow: !!e.checked }
          : branch,
      ),
    );
  };
  const hasChanges = useMemo(() => {
    return getPermissionsDelta().length > 0 || getBranchesDelta().length > 0;
  }, [
    updatedBranchesIds,
    originalBranchesIds,
    updatedPermissions,
    originalPermissions,
  ]);
  return (
    <div style={{ width: '100%' }}>
      <div style={{ marginTop: '24px' }} />
      <div>
        <label
          htmlFor="ingredient2"
          className="ml-2"
          style={{ marginRight: '4px', fontSize: '18px' }}
        >
          שלוחות
        </label>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            gap: '10px',
          }}
        >
          {updatedBranchesIds.map((branchItem) => (
            <div
              className="flex align-items-center"
              style={{ marginLeft: '8px' }}
            >
              <Checkbox
                inputId="ingredient2"
                name="pizza"
                value="Mushroom"
                checked={branchItem.isAllow}
                onChange={(e) => handleBranchesSelectUpdate(e, branchItem)}
              />
              <label
                htmlFor="ingredient2"
                className="ml-2"
                style={{ marginRight: '4px' }}
              >
                {branchItem.branch.branchName}
              </label>
            </div>
          ))}
        </div>
        <div style={{ marginTop: '24px' }} />
        <label
          htmlFor="ingredient2"
          className="ml-2"
          style={{ marginRight: '4px', fontSize: '18px' }}
        >
          הרשאות גישה
        </label>

        {updatedPermissions.map((item) => {
          const permissionValue = item.value;

          return (
            <UserPermissionRow
              key={item.type} // Ensure the key is unique
              permissionName={getPermissionsDisplayText(item.type)}
              read={
                permissionValue && permissionValue !== UserPermissionValue.NONE
              }
              write={permissionValue === UserPermissionValue.WRITE}
              onChange={(newValue) =>
                handlePermissionChange(item.type, newValue)
              }
            />
          );
        })}
      </div>

      {hasChanges && (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'left' }}>
          <Button
            label={'איפוס'}
            outlined={true}
            style={{
              height: '30px',
              marginTop: '8px',
            }}
            onClick={handleReset}
          />
          <Button
            label={'אישור'}
            style={{
              height: '30px',
              marginTop: '8px',
              marginRight: '8px',
            }}
            onClick={handleSubmitUserPermissions}
          />
        </div>
      )}
    </div>
  );
};
